/* eslint-disable react-refresh/only-export-components */
import { NavLink } from "react-router-dom";

import { AdminIcon, type IconName } from "@/components/admin/icon";
import { usePermissions } from "@/hooks/use-permissions";
import { cn } from "@/lib/cn";

export interface SubNavTab {
	to: string;
	label: string;
	icn?: IconName;
	end?: boolean;
	/** L'onglet est visible si l'utilisateur possède au moins une de ces permissions. */
	permissions?: string[];
}

/** L'utilisateur peut-il voir/ouvrir cet onglet ? */
export function canAccessTab(
	tab: SubNavTab,
	hasAny: (...candidates: string[]) => boolean,
	isSuperAdmin: boolean,
): boolean {
	return !tab.permissions || isSuperAdmin || hasAny(...tab.permissions);
}

export function SubNav({
	tabs,
	testId = "sub-nav",
}: {
	tabs: SubNavTab[];
	testId?: string;
}) {
	const { hasAny, isSuperAdmin } = usePermissions();

	const visible = tabs.filter((t) => canAccessTab(t, hasAny, isSuperAdmin));
	if (visible.length <= 1) return null;

	return (
		<div style={{ display: "flex" }}>
			<nav className="sub-nav" data-testid={testId}>
				{visible.map((t) => (
					<NavLink
						key={t.to}
						to={t.to}
						end={t.end}
						className={({ isActive }) =>
							cn("sub-nav-tab", isActive && "sub-nav-tab-active")
						}
						data-testid={`${testId}-${t.to.replaceAll("/", "-").replace(/^-/, "")}`}
					>
						{t.icn && (
							<span className="sub-nav-icn">
								<AdminIcon n={t.icn} s={15} c="currentColor" />
							</span>
						)}
						<span>{t.label}</span>
					</NavLink>
				))}
			</nav>
		</div>
	);
}
